import { useState } from "react";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../../firebase";
import Navbar from "../../Components/Navbar/Navbar"
import Footer from "../../Components/Footer/Footer";
import "./Signup.css"


export default function Signup() {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [name, setName] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const cred = await createUserWithEmailAndPassword(auth, email.trim(), pw);
      if (name) await updateProfile(cred.user, { displayName: name });
      nav("/dashboard");
    } catch (e) {
      setErr(e.message);
    }
    setLoading(false);
  }

  return (
    <>
      <Navbar/>
      <div className="auth-container">
        <div className="auth-card">
          <h2>Create account</h2>
          {err && <div className="auth-error">{err}</div>}
          <form onSubmit={handleSubmit}>
            <label>Name</label>
            <input value={name} onChange={e=>setName(e.target.value)} />
            <label>Email</label>
            <input type="email" value={email} onChange={e=>setEmail(e.target.value)} required />
            <label>Password</label>
            <input type="password" value={pw} onChange={e=>setPw(e.target.value)} required />
            <button className="Signup-button" disabled={loading}>{loading ? "…" : "Sign up"}</button>
          </form>
          <p className="auth-switch">
            Have an account? <Link to="/login">Log in</Link>
          </p>
        </div>
      </div>
    <Footer/>
    
    </>
    );
}